var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "chatGroup" }, [
    _c(
      "div",
      { staticClass: "edit-area" },
      [
        _c("h2", { staticClass: "normal" }, [_vm._v("猩号空间管理")]),
        _vm._v(" "),
        _c("div", { staticClass: "normal" }, [
          _vm._v("\n      空间名称：\n      "),
          _c(
            "div",
            { staticClass: "inputBox" },
            [
              _c("el-input", {
                model: {
                  value: _vm.name,
                  callback: function($$v) {
                    _vm.name = $$v
                  },
                  expression: "name"
                }
              })
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "normal" }, [
          _vm._v("\n      空间类别：\n      "),
          _c(
            "div",
            { staticClass: "inputBox" },
            [
              _c(
                "el-select",
                {
                  attrs: { size: "small" },
                  model: {
                    value: _vm.type,
                    callback: function($$v) {
                      _vm.type = $$v
                    },
                    expression: "type"
                  }
                },
                _vm._l(_vm.geoTypes, function(item) {
                  return _c("el-option", {
                    key: item.key,
                    attrs: { value: item.key, label: item.label }
                  })
                }),
                1
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c(
          "el-button",
          { attrs: { type: "primary" }, on: { click: _vm.upToDb } },
          [_vm._v("保存")]
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { style: _vm.mapHeight, attrs: { id: "real_container" } },
      [
        _c("div", { staticClass: "map-botton" }, [
          _c(
            "div",
            { staticClass: "showNear", on: { click: _vm.showNearChats } },
            [_vm._v("查看周边")]
          ),
          _vm._v(" "),
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.currentCity,
                  expression: "currentCity"
                }
              ],
              on: {
                change: [
                  function($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function(o) {
                        return o.selected
                      })
                      .map(function(o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.currentCity = $event.target.multiple
                      ? $$selectedVal
                      : $$selectedVal[0]
                  },
                  _vm.changeCity
                ]
              }
            },
            _vm._l(_vm.cityList, function(item, index) {
              return _c("option", { key: index, domProps: { value: item } }, [
                _vm._v(_vm._s(item))
              ])
            }),
            0
          ),
          _vm._v(" "),
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.district,
                  expression: "district"
                }
              ],
              on: {
                change: [
                  function($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function(o) {
                        return o.selected
                      })
                      .map(function(o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.district = $event.target.multiple
                      ? $$selectedVal
                      : $$selectedVal[0]
                  },
                  _vm.drawDistrict
                ]
              }
            },
            _vm._l(_vm.areas, function(item, index) {
              return _c("option", { key: index, domProps: { value: item } }, [
                _vm._v(_vm._s(item))
              ])
            }),
            0
          )
        ]),
        _vm._v(" "),
        _c("el-amap-search-box", {
          staticClass: "search-box",
          attrs: {
            "search-option": _vm.searchOption,
            "on-search-result": _vm.onSearchResult
          }
        }),
        _vm._v(" "),
        _c(
          "el-amap",
          {
            ref: "real_map",
            staticClass: "amap-box",
            attrs: {
              vid: "real_map",
              zoom: _vm.zoom,
              center: _vm.center,
              "amap-manager": _vm.amapManager,
              plugin: _vm.plugin,
              events: _vm.events
            }
          },
          [
            _vm.markers.length > 0
              ? _c("el-amap-marker", {
                  attrs: { vid: "real_search_marker", position: _vm.markers }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.lnglat
              ? _c("el-amap-marker", {
                  attrs: {
                    vid: "lnglat_marker",
                    position: _vm.lnglat.split("|"),
                    icon: "./../../static/images/marker1.png"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm._l(_vm.boundary, function(pos, index) {
              return _c("el-amap-marker", {
                key: "boundary" + index,
                attrs: {
                  vid: "boundary" + index,
                  draggable: "true",
                  events: _vm.boundaryEvents,
                  position: pos,
                  offset: [-16, -27],
                  icon: "./../../static/images/marker.png"
                }
              })
            }),
            _vm._v(" "),
            _c("el-amap-polyline", {
              attrs: {
                editable: "false",
                path: _vm.boundaryPath,
                strokeColor: "blue",
                strokeWeight: "2"
              }
            }),
            _vm._v(" "),
            _vm._l(_vm.nearChats, function(item, index) {
              return _c("el-amap-marker", {
                key: "near_chats" + index,
                attrs: {
                  vid: "near_chats" + index,
                  draggable: "true",
                  events: _vm.nearMarkerEvents,
                  position: item.center.coordinates,
                  label: { content: item.name, offset: [10, 12] },
                  icon: item.hasBoundary
                    ? "./../../static/images/marker4.png"
                    : "./../../static/images/otherList.png"
                }
              })
            }),
            _vm._v(" "),
            _vm._l(_vm.nearCircle, function(item, index) {
              return _c("el-amap-polyline", {
                key: "nearline" + index,
                attrs: {
                  editable: "false",
                  path: item,
                  strokeColor: "#007eef",
                  strokeWeight: "2"
                }
              })
            }),
            _vm._v(" "),
            _vm._l(_vm.areaChats, function(item, index) {
              return _c("el-amap-marker", {
                key: "area_chats" + index,
                attrs: {
                  vid: "area_chats" + index,
                  draggable: "true",
                  position: item.center.coordinates,
                  label: { content: item.name, offset: [10, 12] },
                  icon: "./../../static/images/notdb.png"
                }
              })
            }),
            _vm._v(" "),
            _vm._l(_vm.areaChats, function(item, index) {
              return _c("el-amap-polyline", {
                key: "polyline" + index,
                attrs: {
                  editable: "false",
                  path: item.boundary.coordinates,
                  strokeColor: "black",
                  strokeWeight: "2"
                }
              })
            }),
            _vm._v(" "),
            _vm._l(_vm.districtPoints, function(item, index) {
              return _c("el-amap-marker", {
                key: "district_marker" + index,
                attrs: {
                  vid: "district_marker" + index,
                  draggable: "true",
                  position: item.center,
                  label: { content: item.name, offset: [10, 12] },
                  icon: "./../../static/images/marker6.png"
                }
              })
            })
          ],
          2
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-799e2300", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-799e2300","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/ChatGroup.vue
// module id = null
// module chunks = 